import React from 'react';
import ReactDOM from 'react-dom/client';
import { ThemeProvider } from '@mui/material';
import App from './App';
import { BrowserRouter as Router, Route, Routes, useNavigate } from "react-router-dom";
import reportWebVitals from './reportWebVitals';
import theme from './pages/Utils/theme';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { googleclientid } from './pages/Utils/defaults';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Router>
    <ThemeProvider theme={theme}>
      <GoogleOAuthProvider clientId={googleclientid}>
        <App />
      </GoogleOAuthProvider>
    </ThemeProvider>
  </Router>
);
